#version 300 es

void main() {}
